import React, { useEffect, useState } from "react";
import CheckoutButton from "./CheckoutButton";

export default function StickyMobileCta() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="sticky-mobile-cta"
      className={
        "md:hidden fixed bottom-0 left-0 right-0 z-50 transition-transform duration-500 " +
        (visible ? "translate-y-0" : "translate-y-full")
      }
    >
      <div className="backdrop-blur-xl bg-obsidian/85 border-t border-white/10 px-4 py-3 flex items-center gap-3">
        <div className="flex flex-col flex-1">
          <span className="font-display text-base text-ink-50 leading-none">
            77 €
          </span>
          <span className="text-[10px] tracking-[0.2em] uppercase text-ink-400 mt-1">
            accès immédiat
          </span>
        </div>
        <CheckoutButton
          testId="sticky-mobile-cta-button"
          className="!px-5 !py-3 !text-xs"
        >
          Je reprends ma place
        </CheckoutButton>
      </div>
    </div>
  );
}
